import { getRoomIconStr } from '_lib/utils/utilsRoom'
import ChatImg from '@/views/room/IM/MessageList/components/common/ChatImg.js'
import { getEmojiHtml } from '@/directives/emojiHtmlDirective';

function mergeProps(props) {
  return Object.assign({
    webp_quality: 0,
    img: '',
    width: 32,
    radius: 8,
    keep_active: false,
    room_name: '',
    lazy: true,
    animation: true,
    chat_img_props: null,
    only_one_char: false,
  }, props)
}
class RoomAvatar {
  constructor(props = {}) {
    this.props = mergeProps(props)
    this.imgInstance = null;
  }


  render() {
    let classStr = 'cpt-chat-room-avatar flex-center overflow-hidden relative'
    if (this.props.keep_active && !this.props.img) {
      classStr += ' !bg-bd-fl'
    }
    if (!this.props.img) {
      classStr += ' only-text'
    }
    const html = `
      <div
        class="${classStr}" 
        ${this.props.customAttr || ''}
        style="width: ${this.props.width}px; height: ${this.props.width}px; border-radius: ${this.props.radius}px;"
      >
        ${this.props.img ? this.renderImg() : this.renderName()}
      </div>
    `
    return html
  }
  renderImg () {
    const chatImg = new ChatImg({
      src: this.props.img,
      lazy: this.props.lazy,
      animation: this.props.animation,
      webp_quality: this.props.webp_quality,
      classList: ['default-img'],
      thumbnail: `${this.props.width * (this.props.img.includes('.gif') ? 5 : 3)}x`,
      gif_active_type: this.props.chat_img_props?.gif_active_type,
      isActive: this.props.chat_img_props?.is_active,
    });
    this.imgInstance = chatImg;
    // 渲染 ChatImg
    return chatImg.render();
  }
  renderName () {
    if (this.props.room_name) {
      const inner = getEmojiHtml(getRoomIconStr(this.props.room_name, this.props.only_one_char), { width: this.props.icon_width + 'px', height: this.props.icon_width + 'px' })
      return `
        <span class="text-[12px] text-tx-3 font-bold" style="font-size: ${this.props.icon_width}px;${this.props.keep_active ? 'color: #fff;' : ''}">
          ${inner}
        </span>
      `
    }
    return `
      <i
        class="icon-room iconfont text-tx-4 m-0"
        style="width: ${this.props.icon_width}px; height: ${this.props.icon_width}px; font-size: ${this.props.icon_width}px;${this.props.keep_active ? 'color: #fff;' : ''}"
      >
      </i>
    `
  }
  // 初始化事件监听
  initEvents(baseEl) {
    // 初始化 textImg
    if (this.imgInstance && baseEl) {
      const imgEl = baseEl.querySelector('.default-img');
      this.imgInstance.initEvents(imgEl);
    }
  }

  // 销毁组件，解绑事件监听
  destroy(baseEl) {
    if (this.imgInstance && baseEl) {
      const imgEl = baseEl.querySelector('.default-img');
      this.imgInstance.destroy(imgEl);
      this.imgInstance = null;
    }
  }

  updateImgIsActive (newVal) {
    if (this.imgInstance) {
      this.imgInstance.updateImgIsActive(newVal);
    }
  }
}

export default RoomAvatar;